import { memo } from 'react';

function ShipmentsMarker(props) {
  return (
    <svg width={props.dimension} height={props.dimension} viewBox="0 0 23 23" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" >
        {/* Generator: Sketch 52.5 (67469) - http://www.bohemiancoding.com/sketch */}
      <desc>Created with Sketch.</desc>
      <defs>
        <radialGradient cx="50%" cy="0%" fx="50%" fy="0%" r="100%" id="radialGradient-1">
          <stop stopColor="#0CD3C4" offset="0%" />
          <stop stopColor="#05A792" offset="100%" />
        </radialGradient>
      </defs>
      <g id="Map-interactions" stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
        <g id="Group-30" transform="translate(1.000000, 1.000000)">
          <circle id="Oval" stroke="#090F1E" fill={props.backgroundColor ||"url(#radialGradient-1)"} fillRule="nonzero" cx="10.5" cy="10.5" r="10.5" />
        </g>
      </g>
    </svg>
  );
};

export default memo(ShipmentsMarker);
